export default "__VITE_ASSET__nNEOgaMi__"